export const getOrderType = ({
  type,
  giveaway_id: giveawayId,
}: {
  type: any
  giveaway_id: any
}) => {
  if (type === 'GIFT') return giveawayId ? 'Twitch gift redemption' : 'Giveaway links'
  if (type === 'CREATOR_BUDGET') return 'Samples order'

  return 'Order'
}
